import { getSongById, getSongCoverById, startSong } from './player.service';

import { getBase64Image } from '../core/helpers';
import { AudioSingleton } from './AudioSingleton';

export const SONG_STATES = {
	READY: 0,
	PLAYING: 1,
	PAUSE: 2,
	ENDED: 3,
	ERROR: 4
};

export const getSongStateDescription = value => {
	return Object.keys(SONG_STATES).find(key => SONG_STATES[key] === value);
};

AudioSingleton.bindEvents();

export class Song {
	constructor() {
		this.audio = AudioSingleton.getInstance();
		this.almostFinished = null;
		this.onTimeUpdate = this.onTimeUpdate.bind(this);
		this.onEnd = this.onEnd.bind(this);
		this.onError = this.onError.bind(this);
		this.onPause = this.onPause.bind(this);
		this.onPlay = this.onPlay.bind(this);
	}

	async initializeSong(songInfo) {
		try {
			if (!songInfo) return;
			const {
				songId,
				songTitle,
				artistName,
				album,
				genre,
				time,
				musicChannel,
				isSpot = false,
				isJukebox = false
			} = songInfo;
			this.isSpot = isSpot;
			this.isJukebox = isJukebox;
			this.songId = songId;
			this.musicChannel = musicChannel;
			this.songTitle = songTitle;
			this.artistName = artistName;
			this.album = album;
			this.genre = genre;
			const [src, image] = await Promise.all([
				this.loadAudio(songId, isSpot),
				this.createImage(getSongCoverById(songId, isSpot))
			]);
			this.src = src;
			this.image = image;
			this.time = time;
			this.state = SONG_STATES.READY;
			this.currentSongSecond = 0;
			this.percentageOfTheSong = 0;
			return this;
		} catch (err) {
			// Error al inicializar la canción

		}
	}

	async loadAudio(songId, isSpot) {
		return new Promise((resolve, reject) => {
			getSongById(songId, isSpot).then(url => {
				if (!url) {
					const message = 'Cannot generate the url to get the audio';
					// message
					return reject(message);
				}
				const audio = new Audio(url);
				let timeout = setTimeout(() => {
					// El audio multimedia de la canción está listo para reproducirse [tiempo de espera]
					if (timeout) {
						clearTimeout(timeout);
						timeout = null;
					}
					return resolve(url);
				}, 15 * 1000);
				audio.addEventListener(
					'loadedmetadata',
					() => {
						// El audio multimedia de la canción está listo para reproducirse [metadatos cargados]
						if (timeout) {
							clearTimeout(timeout);
							timeout = null;
						}
						return resolve(url);
					},
					false
				);
			});
		});
	}

	async createImage(url) {
		let image = null;
		try {
			const response = await fetch(url, { method: 'HEAD' });
			if (response.ok) {
				image = getBase64Image(url);
			} else {
				console.warn(`Image not found at ${url}`);
				image = require('../img/logo.png');
			}
		} catch (error) {
			console.warn(`Error checking image URL ${url}:`, error);
			image = require('../img/logo.png');
		}
		return image;
	}

	play() {
		this.signal = 'play';
		this.state = SONG_STATES.PLAYING;
		this.audio.src = this.src;
		startSong({
			mediaId: this.songId,
			volume: this.audio.volume,
			isSpot: this.isSpot,
			mediaType: this.type
		});

		// Comenzando a reproducir medios:
		const playPromise = this.audio.play();
		return playPromise ? playPromise.catch(this.onError) : playPromise;
	}

	get volume() {
		return this.audio.volume;
	}

	get type() {
		let type = 'm';

		if (this.isSpot) {
			type = 's';
		} else if (this.isJukebox) {
			type = 'y';
		}

		return type;
	}

	pause() {
		this.signal = 'pause';
		if (
			!this.audio ||
			this.state === SONG_STATES.PAUSE ||
			this.state === SONG_STATES.ENDED
		) {
			return;
		}
		this.audio.pause();
		this.state = SONG_STATES.PAUSE;
	}

	onPause() {
		this.state = SONG_STATES.PAUSE;
	}

	onTimeUpdate() {
		const songDuration = Math.ceil(this.audio.duration);

		this.currentSongSecond = Math.floor(this.audio.currentTime);

		if (
			(songDuration - this.currentSongSecond) === 10 &&
			!this.isSpot &&
			this.almostFinished === null
		) {
			this.almostFinished = true;
		}

		this.percentageOfTheSong = (this.currentSongSecond * 100) / songDuration;
	}

	onEnd() {
		this.state = SONG_STATES.ENDED;
	}

	onError(e) {
		// error
		this.state = SONG_STATES.ERROR;
	}

	onPlay() {
		const isUserSignal = this.signal === 'play';
		if (!isUserSignal) {
			this.audio.pause();
		}
		this.handleOnPlay && this.handleOnPlay(isUserSignal);
	}
}
